(function () {
	const previewSelector = '.product-about__accordion-content[data-collapsed-preview="true"]';
	const animationDuration = 200;

	const getPreviewHeight = (element) => {
		const percentage = Number.parseInt(element.dataset.previewPercentage, 10) || 20;
		const fullHeight = element.scrollHeight;
		return Math.min(fullHeight, Math.max(64, Math.round(fullHeight * percentage / 100)));
	};

	const preparePreview = (element) => {
		const $content = $(element);
		const expanded = $content.hasClass("is-expanded");
		const previewHeight = getPreviewHeight(element);

		element.style.setProperty("--description-preview-height", `${previewHeight}px`);
		element.style.maxHeight = expanded ? "none" : `${previewHeight}px`;
		$content.show();
	};

	const collapseContent = ($content, animate = true) => {
		if (!$content.length) return;

		if ($content.is(previewSelector)) {
			const element = $content[0];
			const startHeight = element.getBoundingClientRect().height || element.scrollHeight;
			const previewHeight = getPreviewHeight(element);

			element.style.setProperty("--description-preview-height", `${previewHeight}px`);
			$content.stop(true, true).show().removeClass("is-expanded");
			element.style.maxHeight = `${startHeight}px`;
			void element.offsetHeight;

			if (animate) {
				$content.animate({ maxHeight: previewHeight }, animationDuration);
			} else {
				element.style.maxHeight = `${previewHeight}px`;
			}
		} else if (animate) {
			$content.stop(true, true).slideUp(animationDuration);
		} else {
			$content.hide();
		}
	};

	const expandContent = ($content, animate = true) => {
		if (!$content.length) return;

		if ($content.is(previewSelector)) {
			const element = $content[0];
			const startHeight = element.getBoundingClientRect().height || getPreviewHeight(element);
			const fullHeight = element.scrollHeight;

			$content.stop(true, true).show().addClass("is-expanded");
			element.style.maxHeight = `${startHeight}px`;
			void element.offsetHeight;

			if (animate) {
				$content.animate({ maxHeight: fullHeight }, animationDuration, function () {
					this.style.maxHeight = "none";
				});
			} else {
				element.style.maxHeight = "none";
			}
		} else if (animate) {
			$content.stop(true, true).slideDown(animationDuration);
		} else {
			$content.show();
		}
	};

	const refreshPreviews = () => {
		$(previewSelector).each(function () {
			const $content = $(this);
			const $title = $content.siblings(".product-about__accordion-title").first();
			const expanded = $title.hasClass("active");

			$content.toggleClass("is-expanded", expanded);
			$title.attr("aria-expanded", expanded ? "true" : "false");
			preparePreview(this);
		});
	};

	const initProductAccordion = () => {
		refreshPreviews();

		$(".product-about__accordion-title")
			.off("click.riadkeshProductAccordion")
			.on("click.riadkeshProductAccordion", function () {
				const $title = $(this);
				const $content = $title.siblings(".product-about__accordion-content").first();

				if (!$title.hasClass("active")) {
					$(".product-about__accordion-title.active").not($title).each(function () {
						const $openTitle = $(this);
						$openTitle.removeClass("active").attr("aria-expanded", "false");
						collapseContent($openTitle.siblings(".product-about__accordion-content").first());
					});

					$title.addClass("active").attr("aria-expanded", "true");
					expandContent($content);
				} else {
					$title.removeClass("active").attr("aria-expanded", "false");
					collapseContent($content);
				}
			});
	};

	document.addEventListener("shopify:section:load", initProductAccordion);
	window.addEventListener("load", refreshPreviews);

	let resizeTimer;
	window.addEventListener("resize", function () {
		window.clearTimeout(resizeTimer);
		resizeTimer = window.setTimeout(refreshPreviews, 150);
	});

	initProductAccordion();
})();
